import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, OnInit } from '@angular/core';
import { AbstractVisbosComponent } from '../../../../core/visbos-core/components/abstract-visbos.component';
import { SessionActions } from '../../../../shared/actions';
import { StocktakingService } from '../../../services/stocktaking/stocktaking.service';
import { Depot } from '../../../../shared/view-model/store-management/depot.type';
import { MessageType } from '../../../../shared/redux-store/session';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'app/core/visbos-core/ui/dialogs/dialog/dialog.component';
import { VisBosComponent } from 'app/visbos.component';
import { Stocktaking } from 'app/store-management/model/stocktaking';

@Component({
  selector: 'vb-rfid-auto-stocktaking-view',
  templateUrl: './rfid-auto-stocktaking-view.component.html',
  styleUrls: ['./rfid-auto-stocktaking-view.component.css']
})
export class RfidAutoStocktakingViewComponent extends AbstractVisbosComponent implements OnInit {

  //TODO: RFID-Permission?
  selectedDepot: Depot;
  stocktakingCuid: string;

  rootViewRef;
  private modal: DialogComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
    private stocktakingService: StocktakingService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver) {
    super(sessionActions, cd);
    this.rootViewRef = (appRef.components[0].instance as VisBosComponent).rootViewRef;
  }

  ngOnInit() {
  }

  depotSelected(depot: Depot) {
    this.selectedDepot = depot;
  }

  startStocktakingClicked() {
    this.stocktakingService.autoStocktakingForDepot({
      depotCuid: this.selectedDepot.cuid
    }).subscribe(res => {

      this.stocktakingCuid = res.data.checkDepotByRfid.cuid;
      if (this.stocktakingCuid) {
        this.createDialog(DialogComponent);
      }

    }, err => {
      this.sessionActions.throwError(err, "Fehler bei der automatischen Lagerinventur");
    });
  }

  createDialog(modalComponent: { new(): DialogComponent }): ComponentRef<DialogComponent> {
    this.rootViewRef.clear();

    let dialogComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(modalComponent);
    let dialogComponentRef = this.rootViewRef.createComponent(dialogComponentFactory);

    this.modal = dialogComponentRef.instance;

    this.modal.confirmQuestion = "Soll die RFID-Inventur abgeschlossen und final versiegelt werden?";
    this.modal.confirmTitle = "RFID-Inventur versiegeln?";
    this.modal.helpText = "";
    this.modal.danger = false;

    dialogComponentRef.changeDetectorRef.detectChanges();

    let confSub = this.modal.confirmClicked.subscribe(() => {

      this.stocktakingService.sealStocktaking(this.stocktakingCuid).subscribe(res => {
        this.sessionActions.pushMessage("Die automatische Lagerinventur wurde erfolgreich abgeschlossen und versiegelt!", MessageType.SUCCESS, "RFID-Inventur abgeschlossen");
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
      }, err => {
        this.sessionActions.throwError(err, "Fehler beim Abschließen der automatischen Lagerinventur");
      });

      this.modal.hide();
    });

    let cancSub = this.modal.cancelClicked.subscribe(() => {
      this.modal.hide();
    });

    this.modal.onClose().subscribe(() => {
      confSub.unsubscribe();
      cancSub.unsubscribe();
      dialogComponentRef.destroy();
    });

    return dialogComponentRef;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/views/rfid-auto-stocktaking-view/rfid-auto-stocktaking-view.component.ts